<template>
  <el-dialog
    title="切换公司"
    v-bind="$attrs"
    width="1000px"
    custom-class="select-company-dialog"
    @close="$emit('update:visible')"
  >
    <div class="select-company-dialog-content">
      <div class="select-company-dialog-content-header">
        <span>公司名称：</span>
        <el-input v-model="searchValue" placeholder="请输入"></el-input>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
      <el-table stripe max-height="580px" :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="公司名称"> </el-table-column>
        <el-table-column prop="contactPerson" label="公司联系人" width="150">
        </el-table-column>
        <el-table-column prop="contactPhoneNumber" label="联系方式" width="110">
        </el-table-column>
        <el-table-column prop="address" label="地址" width="250">
        </el-table-column>
        <el-table-column prop="action" label="操作" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="change(row)">
              切换
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import api from "../../../../common/api";
import Cookie from "@/utils/cookie"; // 验权
export default {
  data() {
    return {
      searchValue: "",
      tableData: [],
      orginTableData: [],
    };
  },
  computed: {
    companyId: () => Cookie.getCookie("companyId"),
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      const { success, data } = await api.user.getAccessibleCompany();
      if (success) {
        this.orginTableData = data;
        this.onSearch();
      }
    },
    onSearch() {
      if (this.searchValue) {
        this.tableData = this.orginTableData.filter(
          (item) =>
            item.name.includes(this.searchValue) && item.id !== this.companyId
        );
      } else {
        this.tableData = this.orginTableData.filter(
          (item) => item.id !== this.companyId
        );
      }
    },
    async change(row) {
      const { success, data } = await api.menu.getMyMenu(row.id, "energy");
      if (success) {
        if (data.length) {
          const {
            success: bindSuccess,
          } = await api.login.bindCompanyOfCurrentSession(row.id);
          if (bindSuccess) {
            this.$emit("update:visible", false);
            Cookie.setCookie("companyId", row.id);
            this.$router.go(0);
          }
        } else {
          this.$message.error("该公司还未创建菜单，请先配置菜单！");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.select-company-dialog {
  .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  &-content {
    &-header {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 400px;
      margin-bottom: 20px;
      span {
        white-space: nowrap;
      }
    }
  }
}
</style>
